/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from '@/utils/loadable';
import { PageLoader } from '@/app/components/loader/page-loader';

export const StaticPageNotFoundPage = lazyLoad(
  () => import('./404'),
  module => module.PageNotFoundPage,
  {
    fallback: <PageLoader />,
  },
);
